module.exports = "/assets/data/cf14ad49bf092aad3c9fa6d148427316-LS24.data.json";